import { render } from "./UserManual.vue?vue&type=template&id=1743e908"
import script from "./UserManual.vue?vue&type=script&lang=js"
export * from "./UserManual.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/admin_web_aaac/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__